<template>
  <g
    class="x-axis"
    :transform="`translate(0, ${
      c.xAxisPosition === 'bottom'
        ? p.scaleY(p.minY)
        : c.legendPosition === 'top'
        ? +c.globalMarginTop + +c.legendHeight
        : +c.globalMarginTop
    })`"
  >
    <g v-for="(datum, index) in p.ticksX" :key="index">
      <line
        :class="[
          'x-axis-tick',
          {
            selected:
              p.tooltipMove &&
              p.tooltipMove.datum &&
              p.tooltipMove.datum[c.xAxis] == datum,
          },
        ]"
        :x1="p.scaleX(datum)"
        :x2="p.scaleX(datum)"
        :y1="c.xAxisPosition === 'top' ? c.xAxisHeight : 0"
        :y2="
          c.xAxisPosition === 'top'
            ? c.xAxisHeight - +c.xAxisTickHeight
            : +c.xAxisTickHeight
        "
        :style="{
          stroke: c.xAxisTickStrokeColor,
          strokeWidth: c.xAxisTickStrokeWidth,
        }"
      />

      <text
        :class="[
          'x-axis-label',
          {
            selected:
              p.tooltipMove &&
              p.tooltipMove.datum &&
              p.tooltipMove.datum[c.xAxis] == datum,
          },
          {
            overlapped: checkLabelOverlap(index, datum),
          },
        ]"
        :x="p.scaleX(datum)"
        :y="c.xAxisPosition === 'bottom' ? +c.xAxisHeight : +c.xAxisFontSize"
        text-anchor="middle"
        :fontSize="c.xAxisFontSize"
        :style="{ fontSize: c.xAxisFontSize }"
      >
        <!-- TODO  -->
        <!-- {{ d[index] && d.find(o => o[c.xAxis] == datum).label ? d.find(o => o[c.xAxis] == datum).label : datum }} -->
        {{ datum }}
      </text>
    </g>
  </g>
</template>

<script>
export default {
  props: ["p", "c", "d", "serie"],
  data() {
    return {
      labelPadding: 15,
    };
  },
  methods: {
    checkLabelOverlap(index, datum, interval = 2) {
      // Only hide year if the amount of data and difference between years is
      // too big for the items to show without overlapping.
      // The numbers 4 and 10 are a bit arbitrary, but there was no time to do it well
      const amountDataPoints = this.d.length;

      if (amountDataPoints > 4) {
        const xAxesValues = this.d.map((datum) => +datum["YEAR"]);
        const minYear = Math.min(...xAxesValues);
        const maxYear = Math.max(...xAxesValues);

        if (maxYear - minYear > 10) {
          let ticks = this.p.ticksX;
          let previous = ticks[index - 1];
          let next = ticks[index + 1];

          if (
            (previous && datum - previous < interval) ||
            (next && next - datum < interval)
          ) {
            if (index % 2) return true;
          } else {
            return false;
          }
        }
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.x-axis {
  .x-axis-label {
    text-anchor: middle;
    fill: $ui-white;
    @include dida-S;

    &.selected {
      fill: red;
    }
    &.overlapped {
      display: none;
    }
  }
}
</style>
